import { BaseModel, SaveType } from "@puntaje/shared/core"

export class InstrumentoMaterial extends BaseModel {
    instrumento_id: number
    material_id: number
    created_at: Date
    updated_at: Date
}
